// session.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CoreStorageService } from '@/core/services/core-storage.service';
import { STORAGE_KEYS } from '@/core/constants/storage-keys';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private isAuthenticated = new BehaviorSubject<boolean>(this.isLoggedIn());
  private homeVariableSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isAuthenticated$ = this.isAuthenticated.asObservable();

  constructor(private coreStorage: CoreStorageService) {}

  setHomeVariable(value: boolean): void {
    this.homeVariableSubject.next(value);
  }

  getHomeVariable(): BehaviorSubject<boolean> {
    return this.homeVariableSubject;
  }

  login() {
    this.coreStorage.setItem(STORAGE_KEYS.TOKEN, 'your-token');
    this.isAuthenticated.next(true);
  }

  logout() {
    this.coreStorage.removeItem(STORAGE_KEYS.TOKEN);
    this.isAuthenticated.next(false);
  }

  isLoggedIn(): boolean {
    const v = this.coreStorage.getItem<any>(STORAGE_KEYS.TOKEN);
    return !!v;
  }
}
